"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconStudyBook = /*#__PURE__*/
function (_Icon) {
  _inherits(IconStudyBook, _Icon);
  function IconStudyBook(props) {
    var _this;
    _classCallCheck(this, IconStudyBook);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconStudyBook).call(this, props));
    _this.name = 'IconStudyBook';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "study-book_svg__group0"
    }, _react2.default.createElement("path", {
      className: "study-book_svg__path0",
      d: "M10.949 20.714a.498.498 0 01-.382-.178c-1.064-1.263-4.013-2.671-9.099-2.836A1.502 1.502 0 010 16.201V2.011C0 1.61.156 1.234.439.95A1.49 1.49 0 011.5.511h.037c3.963.132 8.47 1.241 9.986 3.422C12.937 2.072 16.914.686 21.459.512l.045-.001c.391 0 .749.144 1.033.416.29.277.454.65.463 1.051v13.014a.5.5 0 01-1 0V2.012a.498.498 0 00-.49-.5C15.261 1.75 12 4.105 12 5.3v11.193a.5.5 0 01-1 0V5.301c0-1.212-2.786-3.567-9.499-3.79a.496.496 0 00-.501.5v14.19c0 .271.221.496.492.5 5.421.175 8.637 1.763 9.839 3.191a.5.5 0 01-.382.822z"
    }), _react2.default.createElement("path", {
      className: "study-book_svg__path1",
      d: "M9 6.493a.507.507 0 01-.168-.029 24.282 24.282 0 00-5.403-1.256.5.5 0 01.113-.994c1.917.219 3.81.659 5.627 1.308A.501.501 0 019 6.493z"
    }), _react2.default.createElement("path", {
      className: "study-book_svg__path2",
      d: "M14.5 10.993a.502.502 0 01-.452-.714.496.496 0 01.284-.257 25.286 25.286 0 015.626-1.308.499.499 0 11.114.994c-1.841.21-3.659.633-5.404 1.256a.507.507 0 01-.168.029z"
    }), _react2.default.createElement("path", {
      className: "study-book_svg__path3",
      d: "M9 10.993a.507.507 0 01-.168-.029 24.282 24.282 0 00-5.403-1.256.5.5 0 01.114-.994c1.916.219 3.808.659 5.625 1.308a.501.501 0 01-.168.971z"
    }), _react2.default.createElement("path", {
      className: "study-book_svg__path4",
      d: "M9 14.993a.509.509 0 01-.169-.029 24.468 24.468 0 00-5.453-1.267.497.497 0 01-.44-.553.499.499 0 01.556-.44c1.931.22 3.841.664 5.674 1.319a.499.499 0 01-.168.97z"
    }), _react2.default.createElement("path", {
      className: "study-book_svg__path5",
      d: "M14.5 6.493a.502.502 0 01-.452-.714.497.497 0 01.283-.257 25.455 25.455 0 015.679-1.319.499.499 0 01.449.809.503.503 0 01-.335.186 24.388 24.388 0 00-5.455 1.267.544.544 0 01-.169.028z"
    }), _react2.default.createElement("path", {
      className: "study-book_svg__path6",
      d: "M23.5 23.493a.5.5 0 01-.5-.5v-1.1a2.385 2.385 0 00-2.271-2.401H18.5a.5.5 0 01-.5-.5v-4.75a.75.75 0 00-1.5 0v7.25a.497.497 0 01-.5.5.5.5 0 01-.407-.21l-1.521-2.139a.447.447 0 01-.039-.065.548.548 0 00-.739-.243.551.551 0 00-.244.739l1.413 2.686a.496.496 0 01-.21.675.5.5 0 01-.676-.209L12.16 20.53a1.554 1.554 0 011.38-2.254 1.55 1.55 0 011.366.816l.594.835v-5.684c0-.965.785-1.75 1.75-1.75s1.75.785 1.75 1.75v4.25h1.753A3.39 3.39 0 0124 21.896v1.097a.5.5 0 01-.5.5z"
    })));
    return _this;
  }
  return IconStudyBook;
}(_Icon3.default);
exports.default = IconStudyBook;